import { DadosInstituidorDto } from "@sgprev-dtos"

export class DadosPensao {
    dadosInstituidor?: DadosInstituidorDto;
    requerentes: any // TODO: definir

    constructor(init?: Partial<DadosPensao>) {
        Object.assign(this, init);
    }
}